import React, { useState, useEffect, useMemo } from 'react'
import { Spin, message, Pagination, Select, Button, Dropdown, Menu, Modal, Checkbox, Empty, Tooltip } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import SearchField from "../../home/components/filters/SearchField"
import SelectFilterOptions from "../../shared/SelectFilterOptions"
import { getItemsUnpushEmbroidery } from '../../../services/api/3dApi'
import UnpushEmbroideryCreateBatch from './UnpushEmbroideryCreateBatch'
import { useLocation } from 'react-router-dom'
import { v4 as uuidV4 } from 'uuid'
import { getListBrand, listSku } from '../../../services/api/3dApi'


const ListUnpushEmbroideryPage = () => {
    const location = useLocation()
    const { type } = location.state || {}

    const [filters, setFilters] = useState({
        sku: type ? type : ''
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(100)
    const [listBrand, setListBrand] = useState([])
    const [listSKU, setListSKU] = useState([])
    const [listSize, setListSize] = useState([])
    const [listColor, setListColor] = useState([])
    const [allSelected, setAllSelected] = useState(false)
    const [selectedItems, setSelectedItems] = useState([])
    const [showBulkCreateBatch, setShowBulkCreateBatch] = useState(false)

    const currentData = useMemo(() => data.slice((page - 1) * limit, page * limit), [limit, data, page])

    const fetchListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message: mess } = Data || {}
            const { Brands = [] } = data || {}
            const newBrands = Array.isArray(Brands) && Brands.length > 0 ? Brands.map(i => ({ value: i.name, name: i.name })) : []
            if (!success) {
                throw new Error(mess)
            }
            setListBrand(newBrands)
        } catch (error) {
            console.log(error.message)
        }
    }

    const fetchListSKU = async () => {
        setLoading(true)
        try {
            const { data: response } = await listSku()

            const { data = [], success, error } = response || {}

            if (!success) {
                throw new Error(error)
            }

            const regex = /\s/

            const newData = Array.isArray(data) && data.length > 0 ? data.filter((item) => {
                const { production_process = {} } = item || {}
                const { name } = production_process || {}
                return !regex.test(item.sku) && item && name === 'Thêu'
            }).map(i => ({ value: i.sku, name: i.sku })) : []

            setListSKU(newData)

        } catch (e) {
            console.log(e.message)
        }
    }

    const fetchListSize = async () => {
        try {
            setLoading(true)
            setError('')

            const payload = {
                page: 1,
                limit: 10000,
            }
            const { sku, size, brand } = filters || {}
            if (!!sku) payload.sku = sku

            const { data: response } = await getItemsUnpushEmbroidery(payload)

            const { success, data = [], message: mess, error } = response || {}

            if (!success) {
                throw new Error(mess || error)
            }
            const sizes = Array.isArray(data)
                ? [...new Set(data.map(i => i.size).filter(Boolean))]
                : []

            const colors = Array.isArray(data)
                ? [...new Set(data.map(i => i.size.split('_')[0].trim()).filter(Boolean))]
                : []

            const newData = sizes.map(s => ({ value: s, name: s }))
            const newDataColors = colors.map(c => ({ value: c, name: c }))
            setListSize(newData)
            setListColor(newDataColors)
        } catch (e) {
            console.log(e.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchListSKU()
        fetchListSize()
        fetchListBrand()
    }, [])

    useEffect(() => {
        fetchListSize()
    }, [filters.sku])

    const _handlePageChange = (page) => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const _handleChangeField = (field, value) => {
        const sizeValues = Array.isArray(listSize) ? listSize.filter(i => i.value.startsWith(value)) : []
        setFilters((prevFilters) => ({
            ...prevFilters,
            [field]: Array.isArray(value) ? value : (value ? value.trim() : ''),
            ...(field === 'sku' && !!value ? { color: '', size: [] } : {}),
            ...(field === 'color' ? { size: sizeValues.map(i => i.value) } : {}),
            ...(field === 'size' && (!value || !Array.isArray(value) || !value.length || !(prevFilters.color && value.find(i => i.includes(prevFilters.color)))) ? { color: '' } : {})
        }))
        setPage(1)
    }

    const fetchDataUnpush = async () => {
        try {
            setLoading(true)
            setError('')
            _resetSelectItems()

            const payload = {
                page: 1,
                limit
            }
            const { sku, size = [], brand } = filters || {}
            if (!!sku) payload.sku = sku
            if (Array.isArray(size) && size.length > 0) payload.size = size.join(', ')
            if (!!brand) payload.brand = brand

            const { data: response } = await getItemsUnpushEmbroidery(payload)
            const { success, data = [], message: mess, error } = response || {}

            if (!success) {
                throw new Error(mess || error)
            }
            const newData = Array.isArray(data) ? data.map(i => ({ ...i, _id: uuidV4() })) : []

            setData(newData)
            setTotal(newData.length)

        } catch (e) {
            setError(e.message)
            message.error(e.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchDataUnpush()
    }, [filters, page, limit])

    const _updateItemsSelected = (id, isChecked) => {
        const originData = currentData
        const itemSelect = currentData.find(i => i._id === id)

        if (isChecked) {
            if (!selectedItems.some(i => i._id === id)) {
                setAllSelected(selectedItems.length + 1 === originData.length)
                setSelectedItems([...selectedItems, itemSelect])
            }
        } else {
            const filtered = selectedItems.filter(i => i._id !== id)
            setAllSelected(false)
            setSelectedItems(filtered)
        }
    }

    const _toggleSelectAll = (isChecked) => {
        if (isChecked) {
            // eslint-disable-next-line array-callback-return
            const listId = currentData.filter(i => i._id)
            if (listId.length > 0) {
                setAllSelected(true)
                setSelectedItems(listId)
            } else {
                setAllSelected(false)
                setSelectedItems([])
            }
        } else {
            setAllSelected(false)
            setSelectedItems([])
        }
    }

    const _resetSelectItems = () => {
        setAllSelected(false)
        setSelectedItems([])
    }

    const handleMenuClick = ({ key }) => {
        if ('bulkIdsActionCreateBatch' === key) {
            if (!allSameBrandOrAllMissing(selectedItems)) {
                return message.error(`Không tạo lô nhiều brand!`)
            }
            setShowBulkCreateBatch(true)
        }
    }

    const allSameBrandOrAllMissing = (arr) => {
        if (!Array.isArray(arr) || arr.length === 0) return true

        const normalized = arr.map(item => {
            if (!item || item.brand_name === undefined || item.brand_name === null) return null
            const s = String(item.brand_name).trim()
            return s === "" ? null : s
        })
        // tất cả đều missing
        if (normalized.every(v => v === null)) return true

        // tất cả cùng 1 brand non-null
        const firstBrand = normalized.find(v => v !== null)
        return normalized.every(v => v === firstBrand)
    }

    const _menu = (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key='bulkIdsActionCreateBatch'>Tạo lô</Menu.Item>
        </Menu>
    )

    const SKU_OPTIONS = [
        // { name: 'Tất cả', value: '' },
        ...listSKU
    ]

    const COLOR_OPTIONS = [
        // { name: 'Tất cả', value: '' },
        ...listColor
    ]

    const SIZE_OPTIONS = [
        // { name: 'Tất cả', value: '' },
        ...(filters.color ? listSize.filter(i => !!i.value && i.value.includes(filters.color)) : listSize)
    ]

    const BRAND_OPTIONS = [
        // { name: 'Tất cả', value: '' },
        { name: 'No brand', value: 'NO_BRAND' },
        ...listBrand
    ]

    const totalQuantity = Array.isArray(currentData) && currentData.length > 0 ? currentData.reduce((sum, item) => sum + (item.total || 0), 0) : 0

    return (
        <div className='ListUnpushEmbroideryPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className="mt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className='m-0'>Danh sách item thêu chưa phân lô</h3>
                        </div>

                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <div className='BatchesFilters'>
                                <div className='row align-items-starts'>
                                    <div className='col-12 col-xl-2 mb-3'>
                                        <SelectFilterOptions
                                            placeholder='Chọn SKU'
                                            value={filters.sku || []}
                                            style={{ width: '100%' }}
                                            listOptions={SKU_OPTIONS}
                                            field="sku" label="SKU"
                                            handleChange={_handleChangeField}
                                            disabled={!(Array.isArray(listSKU) && listSKU.length > 0)}
                                            allowClear
                                        />
                                    </div>
                                    <div className='col-12 col-xl-2 mb-3'>
                                        <SelectFilterOptions
                                            placeholder='Chọn color'
                                            value={filters.color || []}
                                            style={{ width: '100%' }}
                                            listOptions={COLOR_OPTIONS}
                                            field="color" label="Color"
                                            handleChange={_handleChangeField}
                                            disabled={!(Array.isArray(listColor) && listColor.length > 0)}
                                            allowClear
                                        />
                                    </div>
                                    <div className='col-12 col-xl-2 mb-3'>
                                        <SelectFilterOptions
                                            placeholder='Chọn size'
                                            value={filters.size || []}
                                            style={{ width: '100%' }}
                                            listOptions={SIZE_OPTIONS}
                                            field="size" label="Size"
                                            handleChange={_handleChangeField}
                                            disabled={!(Array.isArray(listSize) && listSize.length > 0)}
                                            allowClear
                                            mode='multiple'
                                            tokenSeparators={[' ', ',']}
                                        />
                                    </div>
                                    <div className='col-12 col-xl-2 mb-3'>
                                        <SelectFilterOptions
                                            placeholder='Chọn brand'
                                            style={{ width: '100%' }}
                                            listOptions={BRAND_OPTIONS}
                                            field="brand" label="BRAND"
                                            handleChange={_handleChangeField}
                                            disabled={!(Array.isArray(listBrand) && listBrand.length > 0)}
                                            allowClear
                                            value={filters.brand || []}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center">
                            <div className='BulkActionsMenu p-3'>
                                {
                                    <div className='MenuActions d-flex align-items-center'>
                                        <Dropdown overlay={_menu} trigger={['click']}
                                            disabled={loading || !selectedItems.length}
                                        >
                                            <Button>Actions <DownOutlined /></Button>
                                        </Dropdown>
                                        <div className='ml-3 font-weight-300'>
                                            <span>Bạn đã chọn <strong>{selectedItems.length}</strong> items.</span>
                                        </div>
                                    </div>
                                }
                                <UnpushEmbroideryCreateBatch orders={selectedItems.flatMap(d => d.items)} openModal={showBulkCreateBatch} resetOpenModal={setShowBulkCreateBatch} showBtn={false} resetSelectItems={_resetSelectItems} />
                            </div>
                            <div className="headPagination">
                                <Pagination
                                    current={page}
                                    total={total}
                                    pageSize={limit}
                                    showTotal={(sum, range) => sum > 0 &&
                                        <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                        </div>}
                                    onChange={_handlePageChange}
                                    className='text-right'
                                    pageSizeOptions={['10', '20', '50', '100']}
                                    onShowSizeChange={_handleShowSizeChange}
                                />
                            </div>
                        </div>
                        <div className='ListUnpushEmbroideryTable'>
                            <Spin spinning={loading} tip='Đang tải...'>
                                <table className='table table-borderless table-striped'>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>
                                                <Checkbox checked={allSelected} onClick={(e) => _toggleSelectAll(e.target.checked)} />
                                            </th>
                                            <th className="SKU">SKU</th>
                                            <th className="BRAND">Brand</th>
                                            <th className='Size'>Size</th>
                                            <th className="quantity">Quantity {!!totalQuantity && `(${totalQuantity})`}</th>
                                            <th className="action">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            !!currentData && currentData.length > 0 ? (
                                                currentData.map((item, index) => {
                                                    const { sku, brand_name, items, size, total, _id } = { ...item }
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{ verticalAlign: 'top' }}>
                                                                <Checkbox checked={selectedItems.some(i => i._id === _id)} onClick={(e) => _updateItemsSelected(_id, e.target.checked)} />
                                                            </td>
                                                            <td className="SKU">{sku || '-'}</td>
                                                            <td className='BRAND'>
                                                                {brand_name ?
                                                                    <div className='Brand'>
                                                                        <span className="mr-2" onClick={() => _handleChangeField('brand', brand_name)}>{brand_name}</span>
                                                                    </div> : '-'
                                                                }
                                                            </td>
                                                            <td className='Size'>{size || '-'}</td>
                                                            <td className='quantity'>{total || '-'}</td>
                                                            <td>
                                                                <UnpushEmbroideryCreateBatch orders={items} showBtn={true} />
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                )
                                            ) : (
                                                <tr>
                                                    <td colSpan={6}>
                                                        <Empty description='Không có dữ liệu!' />
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </Spin>
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            showQuickJumper
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onChange={_handlePageChange}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListUnpushEmbroideryPage